import React, { useState, useRef, useEffect } from "react";
import { logo } from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { updatePermission } from "../redux/api/PermissionManager";

const TwoStepVerification = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const inputRefs = useRef([]);
  const intervalRef = useRef(null);
  const location = useLocation();
  const { type, email, password, ip_address, device_info } = location?.state;

  const { search } = useLocation();
  // const query = new URLSearchParams(search);
  // const uid = query.get("uid");
  // const token = query.get("token");
  // const email = query.get("email");

  // Start countdown timer
  const startTimer = () => {
    setTimer(30);
    setCanResend(false);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  console.log("type", type, email, password, ip_address, device_info);

  useEffect(() => {
    startTimer();
    return () => clearInterval(intervalRef.current);
  }, []);

  // Handle OTP input change
  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // Allow only single digit
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  // Handle backspace to move to previous input
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // Handle paste: distribute digits across inputs
  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 4);
    const newOtp = [...otp];
    pasted.split("").forEach((char, i) => {
      newOtp[i] = char;
    });
    setOtp(newOtp);
    const nextIndex = Math.min(pasted.length, 3);
    inputRefs.current[nextIndex]?.focus();
  };

  const handleResend = () => {
    if (!canResend) return;

    let formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);
    formdata.append("ip_address", ip_address); // ✅ actual IP
    formdata.append("device_info", device_info); // ✅ OS - Browser
    // Call your resend OTP API here
    post(URLS.LOGIN, formdata)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message || "OTP resent successfully");
          startTimer();
        } else {
          toast.error(res?.message || "Failed to resend OTP");
        }
      })
      .catch(() => {
        toast.error("Server error. Please try again.");
      });
  };

  const handleVerify = () => {
    const otpValue = otp.join("");
    if (otpValue.length < 4) {
      toast.error("Please enter the complete 4-digit OTP.");
      return;
    }

    setLoading(true);
    let formdata = new FormData();
    // formdata.append("uid", uid);
    formdata.append("email", email);
    formdata.append("otp", otpValue);
    formdata.append("password", password);
    formdata.append("ip_address", ip_address); // ✅ actual IP
    formdata.append("device_info", device_info);
    post(URLS.VERIFY_OTP, formdata)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message || "OTP verified successfully");
          updatePermission(res?.admin?.permissions);
          localStorage.setItem("token", res?.token);
          localStorage.setItem("admin_details", JSON.stringify(res?.admin));
          localStorage.setItem(
            "permissions",
            JSON.stringify(res?.admin?.permissions),
          );
          setLoading(false);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1500);
        } else {
          toast.error(res?.message || "Invalid OTP");
        }
        setLoading(false);
      })
      .catch(() => {
        toast.error("Server error. Please try again.");
        setLoading(false);
      });
  };

  return (
    <div className="login-bg">
      <div className="login-left"> </div>
      <div className="login-right">
        <img src={logo} className="logo" alt="logo" />

        <h2
          className="mt-4 f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-26 fs-xxl-28 white"
          style={{ alignItems: "flex-start", display: "flex" }}
        >
          Two Step Verification
        </h2>

        <p
          className="mt-1 f3 fs-sm-12 fs-md-14 fs-lg-14 fs-xxl-20 white"
          style={{ alignItems: "flex-start", display: "flex" }}
        >
          Enter the OTP Check with your SuperAdmin
        </p>

        {/* OTP Input Boxes */}
        <div
          style={{
            display: "flex",
            gap: "32px",
            marginTop: "20px",
            marginBottom: "10px",
            justifyContent: "center",
          }}
        >
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              onPaste={handlePaste}
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "10px",
                border: "none",
                textAlign: "center",
                fontSize: "22px",
                fontWeight: "700",
                color: "#000",
                backgroundColor: "#fff",
                outline: "none",
                caretColor: "#6200ea",
                boxShadow: digit ? "0 0 0 2px #6200ea" : "none",
                transition: "box-shadow 0.2s",
              }}
            />
          ))}
        </div>

        {/* Resend OTP */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          {canResend ? (
            <span
              onClick={handleResend}
              style={{
                color: "#fff",
                fontSize: "13px",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "600",
              }}
            >
              Resend OTP
            </span>
          ) : (
            <span
              style={{
                color: "rgba(255,255,255,0.75)",
                fontSize: "13px",
              }}
            >
              Resend OTP in {timer}s
            </span>
          )}
        </div>

        {/* Verify Button */}
        <button
          onClick={handleVerify}
          className="login-btn f4"
          style={{ borderRadius: 5 }}
        >
          Verify
        </button>

        <p
          className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-14 fs-xxl-20 white"
          style={{
            alignItems: "flex-start",
            display: "flex",
            borderBottom: "1px solid #fff",
            width: 130,
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          Back to login mode
        </p>
      </div>

      {loading && <Loader />}
    </div>
  );
};

export default TwoStepVerification;
